import { Routes } from '@angular/router';
import { DashboardComponent } from './core/layout/pages/dashboard/dashboard.component';

export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];
